/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Number_Of_EventsInputs */

const en_editor_number_of_events = /** @type {(inputs: Editor_Number_Of_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number of events`)
};

const fr_editor_number_of_events = /** @type {(inputs: Editor_Number_Of_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre d'evenements`)
};

const de_editor_number_of_events = /** @type {(inputs: Editor_Number_Of_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl der Ereignisse`)
};

const it_editor_number_of_events = /** @type {(inputs: Editor_Number_Of_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero di eventi`)
};

const ru_editor_number_of_events = /** @type {(inputs: Editor_Number_Of_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Количество событий`)
};

const es_editor_number_of_events = /** @type {(inputs: Editor_Number_Of_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de eventos`)
};

const zh_cn2_editor_number_of_events = /** @type {(inputs: Editor_Number_Of_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件数量`)
};

const ja_editor_number_of_events = /** @type {(inputs: Editor_Number_Of_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント数`)
};

const hi_editor_number_of_events = /** @type {(inputs: Editor_Number_Of_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटनाओं की संख्या`)
};

const pt_pt2_editor_number_of_events = /** @type {(inputs: Editor_Number_Of_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número de eventos`)
};

/**
* | output |
* | --- |
* | "Number of events" |
*
* @param {Editor_Number_Of_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_number_of_events = /** @type {((inputs?: Editor_Number_Of_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Number_Of_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_number_of_events(inputs)
	if (locale === "de") return de_editor_number_of_events(inputs)
	if (locale === "it") return it_editor_number_of_events(inputs)
	if (locale === "ru") return ru_editor_number_of_events(inputs)
	if (locale === "es") return es_editor_number_of_events(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_number_of_events(inputs)
	if (locale === "ja") return ja_editor_number_of_events(inputs)
	if (locale === "hi") return hi_editor_number_of_events(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_number_of_events(inputs)
	return en_editor_number_of_events(inputs)
});